import * as React from 'react'
export const Divider = () => (
  <div className="tw-h-[1px] tw-w-full tw-bg-base-300"></div>
)